import clsx from "clsx";

interface VideoContainerProps {
    src: string;
    enabled: boolean;
}

const Container = ({ src, enabled }: VideoContainerProps) => {
    return (
        <iframe
            src={src}
            allowFullScreen
            className={clsx([
                "w-full aspect-video rounded-3xl",
                enabled ? "pointer-events-none" : "pointer-events-auto",
            ])}
        />
    );
};

export default Container;
